import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activityFrom: {},
    activityId: null,
    unionid: null
  },
  getters: {
    getActivityFrom: state => state.activityFrom,
    getDrawTime: state => state.activityFrom.drawTime || null,
    getActivityId: state => state.activityId,
    getUnionid: state => state.unionid
  },
  mutations: {
    SET_ACTIVITY_FROM(state, activityFrom) {
      state.activityFrom = activityFrom
    },
    SET_ACTIVITY_ID(state, activityId) {
      state.activityId = activityId
    },
    SET_UNIONID(state, unionid) {
      state.unionid = unionid
    }
  },
  actions: {
    setActivityFrom({ commit }, activityFrom) {
      commit('SET_ACTIVITY_FROM', activityFrom)
    },
    setActivityId({ commit }, activityId) {
      commit('SET_ACTIVITY_ID', activityId)
    },
    setUnionid({ commit }, unionid) {
      commit('SET_UNIONID', unionid)
    }
  },
  modules: {}
})
